import React from 'react';
import { Box, TableCell, TableRow, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { RelationsType } from "../../../api/projects-api"
import moment from 'moment';
import { openFileAC, removeAttachmentTC, setCurrentAttachment } from '../../TasksList/tasks-reducer';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PhotoSizeSelectActualTwoToneIcon from '@mui/icons-material/PhotoSizeSelectActualTwoTone';
import { AlertDialog } from '../../common/AlertDialog';
import { OpenAttachment } from '../../common/OpenAttachment';
import { AppRootState } from '../../../app/store';


export type AttachedItemPropsType = {
  file: RelationsType
  projectId: number
  projectName: string
  taskId: number
}

export const AttachedItem = React.memo((props: AttachedItemPropsType) => {
  console.log('FILE url', props.file.url)
  const dispatch = useDispatch()
  const fileName = props.file.attributes.name
  const currentAttachedUrl = useSelector<AppRootState, string>(state => state.workItems.currentAttachmentUrl)
  const currentAttachedType = useSelector<AppRootState, string>(state => state.workItems.currentAttachmentType)

  const removeAttachment = () => {
    dispatch(removeAttachmentTC({ projectName: props.projectName, projectId: props.projectId, taskId: props.taskId, url: props.file.url }))
  }

  const openFile = () => {
    dispatch(openFileAC({ projectId: props.projectId, url: props.file.url, fileName: props.file.attributes.name, filePath: props.file.url }))
  }
  const closeFile = () => {
    dispatch(setCurrentAttachment({ url: '', type: '' }))
  }
  const downloadAttachment = (url: string, fileName: string) => {
    console.log('URL: ', url)
    const linkUrl = document.createElement('a')
    linkUrl.download = fileName
    linkUrl.href = url
    document.body.appendChild(linkUrl)
    linkUrl.click()
    document.body.removeChild(linkUrl)
    linkUrl.remove()
  }

  return (
    <>
      <TableRow
        hover
        key={props.file.attributes.id}
      >
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography >
              {fileName.includes('.jpg') || fileName.includes('.jpeg') || fileName.includes('.png')
                || fileName.includes('.bmp') || fileName.includes('.gif')
                ? <PhotoSizeSelectActualTwoToneIcon /> : <DescriptionOutlinedIcon />
              }
            </Typography>
            <OpenAttachment downloadAttachment={downloadAttachment} removeAttachment={removeAttachment} 
                            name={props.file.attributes.name} openFile={openFile} closeFile={closeFile} 
                            currentAttachedUrl={currentAttachedUrl} currentAttachedType={currentAttachedType}/>
          </Box>
        </TableCell>
        <TableCell >
          <Box sx={{ alignItems: 'center', display: 'flex' }}>
            <Typography variant="caption">
              {Math.round(props.file.attributes.resourceSize / 1024)}K
            </Typography>
          </Box>
        </TableCell>
        <TableCell style={{ textAlign: 'center' }}>
          <Typography variant='caption'>
            {moment(props.file.attributes.resourceCreatedDate).locale('de').format('DD.MM.YYYY')}
          </Typography>
        </TableCell>
        <TableCell style={{ textAlign: 'center' }}>
          <AlertDialog removeAttachment={removeAttachment} fileName={fileName} />
        </TableCell>
      </TableRow>
    </>
  )
})
